/*
 * This module contains utility functions for things related
 * to business updates.
 */

/*
 * Returns an HTML string containing a formatted date.
 * Date is in the format '5 Jul 2020'.
 *
 * @param {string} date - a string containing a timestamp.
 */
export const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  const dayMonth = date.toLocaleString("en-GB", {
    month: "short",
    day: "numeric",
  });
  const year = date.getFullYear();

  return `<strong>${dayMonth}</strong>&nbsp;${year}`;
};
